import type { IconData } from '@stacksjs/iconify-core'

export const pieChartF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19.95 11c-.501 5.053-4.765 9-9.95 9c-5.523 0-10-4.477-10-10C0 4.815 3.947.551 9 .05V11zm0-2H11V.05A10 10 0 0 1 19.95 9\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pieChartF
